import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';
import { userRole_globalAdmin } from '../appConstant';
import { AppGlobals } from '../Services/app.global';

@Injectable()
export class ManageErrorCaseGuard implements CanActivate {
  constructor(
    private _appGlobals: AppGlobals,
  ) {}

  canActivate(
    next: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
      return this._appGlobals.acType.map(acType => acType === userRole_globalAdmin);
  }
}



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/guards/manage-error-case.guard.ts